    <mat-checkbox 
        class="mat-form-field-infix" 
        name="affiliated" 
        [(ngModel)]="affiliated" 
        [disabled]="canEdit === false"
        (change)="checkboxChange($event)">
        Affiliated
    </mat-checkbox>
    <ng-container *ngIf="affiliated">
        <div class="dropdown" #dropdown *ngIf="canEdit; else list">
            <button 
                class="add-site faded trigger">
                <label>Affiliates</label>
                <span class="terms">
                    <span class="term" *ngFor="let affiliate of ( affiliateList() ); trackBy: utils.trackByIndex">
                        <span class="name">{{affiliate}}</span>
                        <mat-icon (click)="removeAffiliate(affiliate)">close</mat-icon>
                    </span>
                </span>
                <input 
                    #searchInput
                    type="search" 
                    placeholder="Add affiliates" 
                    [(ngModel)]="searchText" 
                    (keydown.enter)="addOption(searchText, true)"
                    (keydown.arrowdown)="selectDown()"
                    (keydown.arrowup)="selectUp()"
                    (keydown.backspace)="backspace()"
                    (focus)="toggleOptionsPanel(true)"
                    name="inputSearchTags"
                    autocomplete="inputSearchTags"
                />
            </button>
            <div class="options-panel" id="site-select" [ngClass]="{'open': panelOpen && options.length > 0}">
                <ul class="options">
                    <li *ngFor="let option of options; trackBy: utils.trackByIndex" (click)="optionClick(option)" class="affiliate option" [ngClass]="{'option-selected': isSelected(option)}">
                        <span>{{option}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <ng-template #list>
            <label>Affiliates</label>
            <span *ngIf="affiliates; else placeholderContainer" class="terms placeholder faded">
                <span class="term" *ngFor="let affiliate of ( affiliateList() ); trackBy: utils.trackByIndex">{{affiliate}}</span>
            </span>
            <ng-template #placeholderContainer>
                <span class="placeholder faded">No affiliates added</span>
            </ng-template>
        </ng-template>
    </ng-container>